export const rewardFullModal = () => ({
    root: {
        padding: '24px 24px 16px',
        textAlign: 'center',
    },

    iconWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '24px',
    },

    body1: {
        color: (theme) => (theme.palette.mode === 'dark' ? '#F5F6FA' : 'black'),
        marginBottom: '8px',
    },

    body2: {
        color: (theme) =>
            theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.54)',
        marginBottom: '16px',
    },

    subtitle2: {
        color: (theme) => (theme.palette.mode === 'dark' ? '#F5F6FA' : 'black'),
        marginBottom: '16px',
    },

    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '32px 0',
    },

    errorContainer: {
        padding: '16px',
        textAlign: 'center',
        color: (theme) => (theme.palette.mode === 'dark' ? '#F87171' : '#B00020'),
    },

    affiliateInfo: {
        marginBottom: '16px',
    },

    affiliateContainer: {
        display: 'flex',
        alignItems: 'center',
        border: (theme) =>
            `1px solid ${
                theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'
            }`,
        borderRadius: '8px',
        padding: '8px',
        marginBottom: '16px',
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#212936' : '#ffffff'),
    },

    affiliateLinkText: {
        flexGrow: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        paddingRight: '8px',
        fontFamily: 'monospace',
        color: (theme) =>
            theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.87)' : 'rgba(0, 0, 0, 0.87)',
    },
});
